import { AI_MODEL_LIFECYCLE } from '../../functions/src/common/services/aiModelRouter';

export function modelsNearRetirement(now = new Date()) {
    return AI_MODEL_LIFECYCLE.filter(model => {
        const retirement = new Date(`${model.earliestVertexRetirement}T00:00:00Z`);
        const warningStart = new Date(retirement);
        warningStart.setUTCMonth(warningStart.getUTCMonth() - 1);
        return now >= warningStart && now < retirement;
    });
}
